(() => {
  "use strict";
  const $ = (id) => document.getElementById(id);
  const esc = (s) => String(s ?? "").replace(/[&<>"']/g,
    (ch) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[ch]));

  // Swap the account link for a sign-in prompt when signed out.
  fetch("/api/v1/auth/me").then((r) => {
    if (!r.ok) {
      const link = $("fm-account-link");
      if (link) { link.textContent = "Sign in"; link.href = "/login"; }
    }
  }).catch(() => {});

  // The reader stores a per-chapter position (rd:pos:<project_id>); returning
  // readers see "Continue reading" instead of "Read online".
  function hasReadingPosition(projectId) {
    try { return Number(localStorage.getItem(`rd:pos:${projectId}`) || 0) > 0; }
    catch { return false; }
  }

  // Compact relative age for a post ("3h ago", "5d ago", "Mar 2026").
  function relativeAge(iso) {
    if (!iso) return "";
    const then = Date.parse(iso);
    if (Number.isNaN(then)) return "";
    const mins = Math.max(0, Math.round((Date.now() - then) / 60000));
    if (mins < 60) return `${mins}m ago`;
    const hours = Math.round(mins / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.round(hours / 24);
    if (days < 30) return `${days}d ago`;
    return new Date(then).toLocaleDateString(undefined, { month: "short", year: "numeric" });
  }

  function card(post) {
    const cover = post.cover_url
      ? `<img src="${esc(post.cover_url)}" alt="${esc(post.title)} cover" loading="lazy">`
      : `<div class="fm-cover-empty">No cover</div>`;
    const chapter = post.chapter_number ? `Chapter ${post.chapter_number}` : "";
    // Link the series name to its public page when we know the series id.
    const seriesLabel = post.series_title
      ? (post.series_id
          ? `<a class="fm-series-link" href="/series?id=${esc(post.series_id)}">${esc(post.series_title)}</a>`
          : esc(post.series_title))
      : "";
    const sub = [seriesLabel, chapter].filter(Boolean).join(" · ");
    const readLabel = hasReadingPosition(post.project_id) ? "Continue reading" : "Read online";
    const read = post.pdf_url
      ? `<div class="fm-read-row">
           <a class="ac-btn ac-btn-primary fm-read" href="/read?project=${esc(post.project_id)}">${readLabel}</a>
           <a class="ac-btn fm-read" href="${esc(post.pdf_url)}" target="_blank" rel="noopener">PDF</a>
         </div>`
      : "";
    return `
      <article class="fm-card">
        <div class="fm-cover">${cover}</div>
        <div class="fm-body">
          <strong class="fm-title">${esc(post.title || "Untitled")}</strong>
          ${sub ? `<span class="fm-sub">${sub}</span>` : ""}
          ${post.blurb ? `<p class="fm-blurb">${esc(post.blurb)}</p>` : ""}
          <span class="fm-author">by ${esc(post.author_name || "anonymous")}${
            post.read_count ? ` · 👁 ${post.read_count}` : ""
          }${post.comment_count ? ` · <a class="fm-series-link" href="/read?project=${esc(post.project_id)}#rd-comments">💬 ${post.comment_count}</a>` : ""}${relativeAge(post.created_at) ? ` · ${esc(relativeAge(post.created_at))}` : ""}</span>
          ${read}
        </div>
      </article>`;
  }

  const state = { q: "", page: 1, sort: "recent" };

  function renderPager(body) {
    const pager = $("fm-pager");
    const pages = body.pages || 0;
    if (pages <= 1) { pager.hidden = true; return; }
    pager.hidden = false;
    pager.innerHTML = `
      <button type="button" class="ac-btn" id="fm-prev"${body.page <= 1 ? " disabled" : ""}>&larr; Prev</button>
      <span class="fm-page-label">Page ${body.page} of ${pages}</span>
      <button type="button" class="ac-btn" id="fm-next"${body.page >= pages ? " disabled" : ""}>Next &rarr;</button>`;
    const prev = $("fm-prev");
    const next = $("fm-next");
    if (prev) prev.addEventListener("click", () => { state.page = Math.max(1, state.page - 1); load(); });
    if (next) next.addEventListener("click", () => { state.page += 1; load(); });
  }

  async function load() {
    $("fm-status").hidden = false;
    $("fm-status").textContent = "Loading…";
    try {
      const url = `/api/v1/forum?page=${state.page}&q=${encodeURIComponent(state.q)}&sort=${state.sort}`;
      const res = await fetch(url);
      if (!res.ok) throw new Error(res.statusText);
      const body = await res.json();
      $("fm-status").hidden = true;
      if (!body.posts.length) {
        $("fm-grid").innerHTML = state.q
          ? `<p class='ac-status'>No comics match “${esc(state.q)}”.</p>`
          : "<p class='ac-status'>No comics shared yet. Build one in the studio and post it here.</p>";
        $("fm-pager").hidden = true;
        return;
      }
      $("fm-grid").innerHTML = body.posts.map(card).join("");
      renderPager(body);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (err) {
      $("fm-status").hidden = false;
      $("fm-status").textContent = `Could not load the forum: ${err.message}`;
    }
  }

  let searchTimer;
  const searchInput = $("fm-q");
  if (searchInput) {
    searchInput.addEventListener("input", () => {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => {
        state.q = searchInput.value.trim();
        state.page = 1;
        load();
      }, 300);
    });
  }
  const searchForm = $("fm-search");
  if (searchForm) searchForm.addEventListener("submit", (e) => e.preventDefault());
  const sortSelect = $("fm-sort");
  if (sortSelect) {
    sortSelect.addEventListener("change", () => {
      state.sort = ["popular", "discussed"].includes(sortSelect.value) ? sortSelect.value : "recent";
      state.page = 1;
      load();
    });
  }

  load();
})();
